/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    setTimeout(function () {
      var el = document.querySelector(".gb-totals-total-value");
      var cart_total = el ? (el.textContent || "").trim() : "";
      if (cart_total >= amountFreeProduct) {
        if (document.querySelector(".cart-item.gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          var trigger = document.querySelector(".gb-free-product-trigger");
          if (trigger) trigger.click();
        }
      } else {
        console.log("Removing free product - under threshold");
        var removeBtn = document.querySelector(".gb-remove-product");
        if (removeBtn) removeBtn.click();
      }
    }, 3000);

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest(".gb-sumbit-free")) return;
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (!document.querySelector(".cart-item.gb-find-remove-product")) {
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);
    });
  }

  document.body.addEventListener("click", async function (e) {
    var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
    if (!label) return;
    if (e.target.tagName === "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem && curElem.classList.contains("checked");

    if (!wasChecked) {
      if (!curElem || !curInputElem || !spinAnim || !checkElem) return;
      if (spinAnim.style.display === "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;

      const removeCallback = () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.checked = false;
      };

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: shippingProductId, quantity: 0 }),
        })
          .then(() => fetch(routes.cart_url + "?view=drawer"))
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(() => {
            removeCallback();
          });
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var form = document.getElementById("CartDrawer-Form");
      if (!form) return;
      var cartItems = form.querySelectorAll(".cart-item");
      if (cartItems.length === 0) {
        console.log("No items in cart, preventing checkout");
        e.preventDefault();
        return false;
      }
      console.log("Cart checkout with", cartItems.length, "items");
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Get the persistent text (e.g., "Buy Now")
      const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const interval = setInterval(() => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          clearInterval(interval);
          updateAllPrices(selectedBundle);
          setupButtonObserver();
        }
      }, 300);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const interval = setInterval(() => {
    const app = document.querySelector('kaching-bundle');
    if (app) {
      clearInterval(interval);
      initApp(app);
    }
  }, 300);
};

window.addEventListener('DOMContentLoaded', KachingApp);

// Swatch King color-swatch row: visible "more colors" affordance.
// The base overflow-x:auto/max-width fix (assets/base.css + assets/
// shop-product-details.css) makes the row scrollable, but gives no visual
// hint that more colors exist beyond the first 4. This adds that hint:
// - Product cards: a "+N" overlay on whichever swatch is currently last
//   visible, re-anchored live as the row scrolls, and hidden once there's
//   nothing left to reveal.
// - Product page: round prev/next arrow buttons at the edges of the row,
//   each shown only while there's more content on that side, plus a
//   gradient fade on the same side so the cut-off swatch photo doesn't
//   stop abruptly.
// Swatch King injects its markup asynchronously (a theme app extension
// script, not our own Liquid), so this polls for it the same way
// KachingApp above waits for <kaching-bundle>, instead of assuming a
// fixed load order.
(function () {
  // Swatch King attaches its own click handler directly on each
  // <variant-swatch-king> element to select a swatch when anything inside
  // it is clicked/pressed. Our overlay/arrows live inside that same
  // element (they have to, to sit next to the swatches), so a press on
  // them would otherwise also register as a swatch selection. Intercept
  // pointerdown/mousedown/touchstart at the window-capture phase - the
  // earliest point in the whole dispatch, ahead of any bubble-phase
  // listener Swatch King registers on an element further down the tree -
  // so their handler never sees the press at all.
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    window.addEventListener(
      type,
      function (e) {
        if (e.target.closest && e.target.closest('.swatch-more-overlay, .swatch-scroll-arrow')) {
          e.stopPropagation();
        }
      },
      true
    );
  });

  function buildOverlay() {
    var el = document.createElement('div');
    el.className = 'swatch-more-overlay';
    el.setAttribute('role', 'button');
    return el;
  }

  function buildArrow(direction, small) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className =
      'swatch-scroll-arrow' + (small ? ' swatch-scroll-arrow--small' : '') + (direction === 'prev' ? ' swatch-scroll-arrow--prev' : '');
    btn.setAttribute('aria-label', direction === 'prev' ? 'Vorige kleuren tonen' : 'Meer kleuren tonen');
    var iconSize = small ? 6 : 10;
    btn.innerHTML =
      '<svg width="' +
      iconSize +
      '" height="' +
      iconSize +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    return btn;
  }

  function buildFade(direction) {
    var el = document.createElement('div');
    el.className = 'swatch-scroll-fade' + (direction === 'prev' ? ' swatch-scroll-fade--prev' : ' swatch-scroll-fade--next');
    return el;
  }

  // Fade stretches to the row's full height, and is a few px WIDER than
  // the arrow it sits behind on each side - painted over the row (a
  // solid background gradient, not a transparency mask), so it physically
  // covers the currently-selected swatch's own "selected" border, which
  // does not consistently respect a mask-image/opacity applied elsewhere
  // (confirmed by sampling rendered pixel colors across several
  // approaches). The extra width is a safety margin against any
  // px-rounding gap between this element and the row's own edge.
  function positionFade(el, row, wrapper, edge, width) {
    var rr = rowRectIn(row, wrapper);
    var overhang = 4;
    el.style.top = rr.top + 'px';
    el.style.height = rr.height + 'px';
    el.style.width = width + overhang + 'px';
    el.style.left = (edge === 'start' ? rr.left - overhang : rr.left + rr.width - width) + 'px';
  }

  // `wrapper` (.swatch-single) is not reliably the same width/position as
  // `row` (the actual scrolling element) - on the PDP it happens to match,
  // but on product cards `wrapper` spans the full card width while `row`
  // is capped narrower (assets/base.css max-width), and on the PDP
  // `wrapper` also contains the "Kleur" legend above the row. Everything
  // is positioned from the row's own measured rect, relative to wrapper,
  // rather than assumed CSS top:0/left:0/right:0.
  function rowRectIn(row, wrapper) {
    var r = row.getBoundingClientRect();
    var w = wrapper.getBoundingClientRect();
    return { top: r.top - w.top, left: r.left - w.left, width: r.width, height: r.height };
  }

  // Fixed-size arrow, vertically centered on the row - never stretched to
  // the row's height (that produced a tall pill-shaped block instead of a
  // small round button). `outside`: place the arrow just past the row's
  // own edge instead of inset over it - needed on product cards, where
  // the "next" arrow would otherwise land directly on top of the "+N"
  // badge (both want the same last-item corner) since `wrapper` is wider
  // than `row` there (unlike the PDP, where they're the same width and
  // inset is the only option that stays within wrapper's bounds).
  function positionArrow(el, row, wrapper, edge, size, outside) {
    var rr = rowRectIn(row, wrapper);
    el.style.top = rr.top + (rr.height - size) / 2 + 'px';
    if (edge === 'start') {
      el.style.left = (outside ? rr.left - size - 2 : rr.left + 2) + 'px';
    } else {
      el.style.left = (outside ? rr.left + rr.width + 2 : rr.left + rr.width - size - 2) + 'px';
    }
    el.style.right = 'auto';
  }

  function initRowNav(container, wrapper, options) {
    var arrowSize = options.arrowSize;
    var fadeWidth = options.fadeWidth;
    var step = options.step;
    var small = options.small;
    var nextArrowOutside = options.nextArrowOutside;

    var prevArrow = buildArrow('prev', small);
    var nextArrow = buildArrow('next', small);
    var prevFade = buildFade('prev');
    var nextFade = buildFade('next');
    prevArrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      container.scrollBy({ left: -step, behavior: 'smooth' });
    });
    nextArrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      container.scrollBy({ left: step, behavior: 'smooth' });
    });
    wrapper.appendChild(prevFade);
    wrapper.appendChild(nextFade);
    wrapper.appendChild(prevArrow);
    wrapper.appendChild(nextArrow);

    return function update() {
      positionArrow(prevArrow, container, wrapper, 'start', arrowSize, false);
      positionArrow(nextArrow, container, wrapper, 'end', arrowSize, nextArrowOutside);
      positionFade(prevFade, container, wrapper, 'start', fadeWidth);
      positionFade(nextFade, container, wrapper, 'end', fadeWidth);
      var maxScroll = container.scrollWidth - container.clientWidth;
      var atStart = container.scrollLeft <= 1;
      var atEnd = container.scrollLeft >= maxScroll - 1;
      prevArrow.style.display = atStart ? 'none' : 'flex';
      nextArrow.style.display = atEnd ? 'none' : 'flex';
      prevFade.style.display = atStart ? 'none' : 'block';
      nextFade.style.display = atEnd ? 'none' : 'block';
    };
  }

  function initPdpRow(container, wrapper) {
    var updateNav = initRowNav(container, wrapper, { arrowSize: 26, fadeWidth: 28, step: 190, small: false });
    container.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function initCardRow(container, wrapper, items) {
    var updateNav = initRowNav(container, wrapper, {
      arrowSize: 16,
      fadeWidth: 14,
      step: 30,
      small: true,
      nextArrowOutside: true,
    });

    var overlay = buildOverlay();
    var currentOverlayWrapper = null;

    function updateBadge() {
      var visibleRight = container.scrollLeft + container.clientWidth;
      var lastVisibleIndex = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetLeft + items[i].offsetWidth <= visibleRight + 1) {
          lastVisibleIndex = i;
        }
      }
      var remaining = items.length - 1 - lastVisibleIndex;
      if (remaining <= 0) {
        overlay.remove();
        currentOverlayWrapper = null;
        return;
      }
      overlay.textContent = '+' + remaining;
      overlay.setAttribute('aria-label', remaining + ' meer kleuren tonen');
      var targetWrapper = items[lastVisibleIndex].querySelector('.swatch-image-wrapper') || items[lastVisibleIndex];
      if (targetWrapper !== currentOverlayWrapper) {
        if (getComputedStyle(targetWrapper).position === 'static') {
          targetWrapper.style.position = 'relative';
        }
        targetWrapper.appendChild(overlay);
        currentOverlayWrapper = targetWrapper;
      }
    }

    function update() {
      updateNav();
      updateBadge();
    }

    container.addEventListener('scroll', update);
    window.addEventListener('resize', updateNav);
    update();
  }

  function initSwatchRow(container) {
    if (container.dataset.swatchNavInit) return;
    var items = container.querySelectorAll('.swatch-view-item');
    var isPDP = !!container.closest('.shop-product-inner-container');
    // The PDP row is capped to a fixed width (the "peek" design - assets/
    // shop-product-details.css), so it reliably shows ~4 items regardless
    // of content; more than 4 always means there's overflow to scroll to.
    // The card row now fills the card's own width (see assets/base.css),
    // so how many items fit varies by card size - "more than 4" is no
    // longer a valid stand-in for "will overflow" there, so only skip the
    // trivial 0/1-item case and let the dynamic overflow checks in
    // updateNav/updateBadge decide whether anything needs to show.
    if (isPDP ? items.length <= 4 : items.length < 2) return;

    var wrapper = container.closest('.swatch-single');
    if (!wrapper) return;
    container.dataset.swatchNavInit = 'true';
    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    if (isPDP) {
      initPdpRow(container, wrapper);
    } else {
      initCardRow(container, wrapper, items);
    }
  }

  // Swatch King requests its color-swatch thumbnails from Shopify's image
  // CDN with a hardcoded "crop=top" parameter baked into the URL - the
  // image arrives from the CDN already cropped to a square, before any of
  // our CSS ever sees it, so a background-position rule has no pixels left
  // to reposition (a background-size:cover square image inside an
  // equally-square box has no slack to shift). Rewriting the URL itself to
  // crop=center is the only way to actually change which part of the
  // photo shows. This does NOT fix products whose color photos are shot
  // at genuinely different zoom levels to begin with (verified for at
  // least one product - see chat) - no crop parameter can make a close-up
  // and a full-body shot of the same garment look the same scale.
  function fixSwatchCrop() {
    document.querySelectorAll('.star-set-image').forEach(function (el) {
      var bg = el.style.backgroundImage;
      if (bg && bg.indexOf('crop=top') !== -1) {
        el.style.backgroundImage = bg.replace(/crop=top/g, 'crop=center');
      }
    });
  }

  // Product cards: variant-swatch-king now renders below the title (see
  // assets/base.css - CSS `order`, not a DOM move), but the gap between
  // them isn't fixed - .collection-product-info has a min-height (mobile
  // grid-row-alignment rule, assets/collection-grid-page.css) that
  // leaves a variable amount of slack below the title depending on how
  // long it is, so a flat negative margin over/under-corrects depending
  // on the product. Measure the actual rendered gap per card and set
  // exactly enough negative margin to bring it down to ~10px, instead of
  // guessing a single fixed value that only happens to work for one
  // title length.
  function fixCardSwatchSpacing() {
    var targetGap = 10;
    document.querySelectorAll('.product-card-link > variant-swatch-king').forEach(function (swatchKing) {
      // DOM order is unchanged (order:1 in assets/base.css is a purely
      // visual reorder) - variant-swatch-king is still the first child,
      // so .collection-product-info is its NEXT sibling, not previous.
      var info = swatchKing.nextElementSibling;
      if (!info || !info.classList.contains('collection-product-info')) return;
      var title = info.querySelector('.product-title');
      if (!title) return;
      // Measure against the actual first visible swatch item, not
      // variant-swatch-king's own box - Swatch King's inner
      // .swatches-type-collections wrapper carries its own separate
      // margin-top (its default spacing for the row's original position,
      // directly under the photo), which isn't reflected by the outer
      // element's own bounding box.
      var firstSwatchItem = swatchKing.querySelector('.swatch-view-item');
      if (!firstSwatchItem) return;
      // Skip re-measuring once already close to the target - avoids
      // resetting margin-top to 0 and back on every 400ms poll tick
      // (this runs repeatedly to self-correct for late font/image loads
      // shifting the title's height, not just once on init).
      var currentGap = firstSwatchItem.getBoundingClientRect().top - title.getBoundingClientRect().bottom;
      if (Math.abs(currentGap - targetGap) <= 1) return;
      swatchKing.style.marginTop = '0px';
      var naturalGap = firstSwatchItem.getBoundingClientRect().top - title.getBoundingClientRect().bottom;
      if (naturalGap > targetGap) {
        swatchKing.style.marginTop = -(naturalGap - targetGap) + 'px';
      }
    });
  }

  function scanForSwatchRows() {
    document.querySelectorAll('.swatch-view.swatch-view-image').forEach(initSwatchRow);
    fixSwatchCrop();
    fixCardSwatchSpacing();
  }

  var scanInterval = setInterval(scanForSwatchRows, 400);
  setTimeout(function () {
    clearInterval(scanInterval);
  }, 15000);
})();

// PDP hero image: max-height needs to account for the sticky header, not
// just a flat 90vh - assets/shop-product-details.css caps the image at
// 90vh so it doesn't run taller than the viewport, but the sticky header
// (and, at the top of a fresh page load, the announcement bar above it,
// which is not sticky but is still on-screen at that point) sits on top
// of it and isn't accounted for by a flat vh value, so the two together
// could still exceed the actual visible height. Measured the same way as
// the existing --thumb-column-height precedent (assets/product-gallery.js)
// - JS measures the real rendered height and exposes it as a CSS custom
// property - kept here rather than in that file since it's part of the
// "Shop" app's own generated bundle and could be overwritten by it.
(function () {
  function updatePdpHeroTopOffset() {
    var announcement = document.querySelector('.announcement-bar-section');
    var stickyHeader = document.querySelector('.shopify-section-header-sticky');
    var total = 0;
    if (announcement) total += announcement.getBoundingClientRect().height;
    if (stickyHeader) total += stickyHeader.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--pdp-hero-top-offset', total + 'px');
  }

  if (document.querySelector('.shop-carousel-container')) {
    updatePdpHeroTopOffset();
    window.addEventListener('resize', updatePdpHeroTopOffset);
  }
})();